import { textVariant } from '@astro-ui/fondations/text'
import { Interpolation, Theme, TypographyProps } from '@mui/material'

export const convertToTypographyVariant = (obj: typeof textVariant) =>
  Object.keys(obj).flatMap((category) =>
    Object.keys(obj[category as keyof typeof obj]).map((key) => {
      const variant = `${category}-${key}`
      return {
        props: {
          variant: variant.replace(/ /g, '-'),
        },
        style: obj[category as never][key],
      }
    }),
  ) as {
    props: Partial<TypographyProps>
    style: Interpolation<{
      theme: Theme
    }>
  }[]
